// Models
import { Channel } from '../models';

export namespace ChannelActions {
	export class GetAll {
		static readonly type = '[Channel] Get Channels';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}

	export class SetAll {
		static readonly type = '[Channel] Set Channels';
		constructor(public channels: Channel[]) {}
	}

	export class Update {
		static readonly type = '[Channel] Update Channel';
		constructor(public data: { channel: Channel; showSpinner?: boolean; showToast?: boolean } = { channel: null, showSpinner: false, showToast: false }) {}
	}

	export class UpdateSuccess {
		static readonly type = '[Channel] Update Channel Success';
		constructor(public channel: Channel) {}
	}

	export class UpdateError {
		static readonly type = '[Channel] Update Channel Error';
	}
}
